import React from 'react';
import clsx from 'clsx';
import InternalBox from '../box/internal';
import styles from './styles.css.js';
export default function AxisLabel(_a) {
    var _b;
    var title = _a.title, horizontalBars = _a.horizontalBars, position = _a.position;
    if (!title) {
        return null;
    }
    return (React.createElement(InternalBox, { className: clsx(styles['axis-label'], (_b = {},
            _b[styles['axis-label--x']] = (horizontalBars && position === 'left') || (!horizontalBars && position !== 'left'),
            _b[styles['axis-label--y']] = (horizontalBars && position === 'bottom') || (!horizontalBars && position !== 'bottom'),
            _b)), fontWeight: "bold", textAlign: position === 'left' ? 'left' : 'center', margin: { bottom: position === 'left' ? 'l' : 'n' } },
        React.createElement("span", { "aria-hidden": "true" }, title)));
}
//# sourceMappingURL=axis-label.js.map